import React from 'react';
import type { FormRule } from 'antd';
import { Form, InputNumber } from 'antd';
import { FormCurrencySelect } from 'components/common/form-currency-select/form-currency-select';
import type { IInvoiceFormProps, IInvoiceFormFields } from 'components/invoices/invoice-form/types';
import styles from './invoice-form.module.scss';

const validationRule: Record<keyof IInvoiceFormFields, FormRule[]> = {
  price: [{ required: true, type: 'number', min: 1 }],
  currency: [{ required: false, type: 'string' }],
  vat: [{ required: false, type: 'integer', min: 0, max: 100 }],
};

export const InvoiceForm: React.FC<IInvoiceFormProps> = (props) => {
  const { form, formId, onFinish, initialValues } = props;

  return (
    <Form form={form} id={formId} layout='vertical' initialValues={initialValues} onFinish={onFinish}>
      <Form.Item label='Price' name='price' rules={validationRule.price}>
        <InputNumber
          placeholder='Price'
          type='number'
          className={styles.inputFullWidth}
          addonAfter={<FormCurrencySelect />}
        />
      </Form.Item>
      <Form.Item label='VAT' name='vat' rules={validationRule.vat}>
        <InputNumber placeholder='Vat' type={'number'} className={styles.inputFullWidth} addonAfter='%' />
      </Form.Item>
    </Form>
  );
};
